import { Action, ActionReducer } from '@ngrx/store';
import { AuthState } from './auth/auth.state';
import { UiState } from './ui/ui.state';
import { uiReducer } from './ui';
import { authReducer } from './auth';

export interface AppState {
  ui: UiState;
  auth: AuthState;
}

export interface AppStore {
  ui: ActionReducer<UiState, Action>;
  auth: ActionReducer<AuthState, Action>;
}

export const appStore: AppStore = {
  ui: uiReducer,
  auth: authReducer,
};
